module.exports = __webpack_public_path__ + "img/Lugares para visitar.61d04784.png";